module.exports = __webpack_public_path__ + "static/media/blog_img8.2a31e2f4.jpg";